
        import '/home/builduser/work/c1dd1064fea009a6/santa-editor/packages/panels/rightPanels/openedRightPanels/rightPanels.scss.css.virtualfile';
        module.exports = {"right-panels":"_right-panels_1l8vd_7","rightPanels":"_right-panels_1l8vd_7"};